<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="EMPENHO RESTO A PAGAR"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/invoice.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/empenhos-resto']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar empenho</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-9">
          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="180px" imagem="assets/img/money-contract.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="form-group col-2">
                  <label for="numero_empenho" class="font-weight-bold">
                    Empenho Nº:
                  </label>
                  <span class="form-control font-weight-bold text-right">
                    {{("00000" + entidadeForm.get('numero').value).slice(-5) }}
                  </span>
                </div>
                <div class="form-group col-md-3">
                  <label for="ano">Ano Empenho</label>
                  <input (change)="atualizarCompraAutoComplete()" formControlName="ano" type="text" class="form-control"
                    id="ano">
                </div>
                <div class="form-group col-md-3">
                  <label for="data_empenho">Data empenho<span class="text-danger">*</span></label>
                  <p-calendar id="data_empenho" formControlName="data_empenho" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                    [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
                <div class="form-group col-md-3 offset-1">
                  <label for="valor_empenho" class="font-weight-bold">Valor<span class="text-danger">*</span></label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                    class="form-control text-right font-weight-bold" id="valor_empenho" placeholder="0,00">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-2">
                  <label for="processo">N˚ Processo</label>
                  <input formControlName="processo" type="text" class="form-control" id="processo">
                </div>
                <div class="form-group col-md-3">
                  <label for="compra">Nº Compra</label>
                  <p-autoComplete [disabled]="!this.entidadeForm.get('ano').value" #compra_ formControlName="compra"
                    [field]="compraAutoComplete.conversor" id="compra" [suggestions]="compraAutoComplete.lista"
                    (completeMethod)="compraAutoComplete.filtrar($event)" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="compraAutoComplete">
                    <ng-template let-compra pTemplate="item">
                      {{compra.numero}}/{{compra.exercicio.ano}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="form-group col-md-3">
                  <label for="data_vencimento">Previsão Pagto</label>
                  <p-calendar #data_vencimento_ id="data_vencimento" formControlName="data_vencimento"
                    inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR"
                    [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
                <div class="form-group col-md-3 offset-1">
                  <label for="contrato">Contrato</label>
                  <p-autoComplete formControlName="contrato" [field]="contratoAutoComplete.conversor"
                    [suggestions]="contratoAutoComplete.lista" (completeMethod)="contratoAutoComplete.filtrar($event)"
                    placeholder="Nº Contrato" inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }"
                    (onSelect)="contratoAutoComplete.atualizar(true)" (onBlur)="contratoAutoComplete.atualizar(true)"
                    [forceSelection]="true" [autoHighlight]="true" *ngIf="contratoAutoComplete">
                    <ng-template let-contrato pTemplate="item">
                      {{contrato.numero}} <span
                        *ngIf="contrato.aditivo !== null && contrato.aditivo > 0 ">{{contrato.aditivo}}</span>
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="580px" imagem="assets/img/financial.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="col-md-12">
                  <label for="favorecido" style="display: block">Beneficiário<span class="text-danger">*</span></label>
                  <div class="form-group col-md-3 p-0 float-left">
                    <input class="form-control font-weight-bold" type="text"
                      (blur)="favorecidoAutoComplete.atualizar(false)" [(ngModel)]="favorecidoAutoComplete.id"
                      name="favorecido_id" [ngModelOptions]="{standalone: true}" *ngIf="favorecidoAutoComplete"
                      placeholder="código" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                      [suggestions]="favorecidoAutoComplete.lista"
                      (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                      placeholder="Informe cpf/cnpj ou nome/razão social"
                      inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                      (onSelect)="favorecidoAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                      *ngIf="favorecidoAutoComplete">
                      <ng-template let-favorecido pTemplate="item">
                        {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <label for="subelemento" style="display: block">Subelemento da despesa<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" formControlName="subelemento" type="text" unmask="unmask"
                      [imask]="{mask: '0.0.00.00.00.000'}" *ngIf="subElementoAutoComplete" placeholder="código" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="subelemento_nome" [field]="conversor"
                      [suggestions]="subElementoAutoComplete.lista"
                      (completeMethod)="subElementoAutoComplete.filtrar($event)"
                      placeholder="Informe a descrição do subelemento" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="subElementoAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="subElementoAutoComplete">
                      <ng-template let-subElemento pTemplate="item">
                        {{subElemento.codigo}} - {{subElemento.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="form-group col-12">
                  <label for="acao" style="display: block">Ação Governamental<span class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" formControlName="acao" type="text" *ngIf="acaoAutoComplete"
                      placeholder="acao" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="acao_nome" [field]="conversor"
                      [suggestions]="acaoAutoComplete.lista" (completeMethod)="acaoAutoComplete.filtrar($event)"
                      placeholder="Informe a ação de governo" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="acaoAutoComplete.atualizar(true)" [forceSelection]="true"
                      [autoHighlight]="true" *ngIf="acaoAutoComplete">
                      <ng-template let-acao pTemplate="item">
                        {{acao.codigo}} {{acao.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="programa" style="display: block">Programa de Governo<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" formControlName="programa" type="text" *ngIf="programaAutoComplete"
                      placeholder="programa" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="programa_nome" [field]="conversor"
                      [suggestions]="programaAutoComplete.lista" (completeMethod)="programaAutoComplete.filtrar($event)"
                      placeholder="Informe a descrição do programa" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="programaAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="programaAutoComplete">
                      <ng-template let-programa pTemplate="item">
                        {{programa.codigo}} - {{programa.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="funcao" style="display: block">Função do Governo<span class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="funcaoAutoComplete.atualizar(false)"
                      formControlName="funcao" name="funcao_id" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="funcao_nome" [field]="conversor"
                      [suggestions]="funcaoAutoComplete.lista" (completeMethod)="funcaoAutoComplete.filtrar($event)"
                      placeholder="Informe a função do governo" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="funcaoAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="funcaoAutoComplete">
                      <ng-template let-funcao pTemplate="item">
                        {{funcao.codigo}} {{funcao.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="subfuncao" style="display: block">Sub-Função do Governo<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="subFuncaoAutoComplete.atualizar(false)"
                      formControlName="subfuncao" name="subFuncao_id" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="subfuncao_nome" [field]="conversor"
                      [suggestions]="subFuncaoAutoComplete.lista"
                      (completeMethod)="subFuncaoAutoComplete.filtrar($event)"
                      placeholder="Informe a sub-função do governo" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="subFuncaoAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="subFuncaoAutoComplete">
                      <ng-template let-subFuncao pTemplate="item">
                        {{subFuncao.codigo}} {{subFuncao.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="aplicacao" style="display: block">Aplicação<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="aplicacaoAutoComplete.atualizar(false)"
                      formControlName="aplicacao" name="aplicacao_id" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="aplicacao_nome" [field]="conversor"
                      [suggestions]="aplicacaoAutoComplete.lista"
                      (completeMethod)="aplicacaoAutoComplete.filtrar($event)"
                      placeholder="Informe a aplicação" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="aplicacaoAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="aplicacaoAutoComplete">
                      <ng-template let-aplicacao pTemplate="item">
                        {{aplicacao.codigo}} {{aplicacao.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

                <div class="col-md-12">
                  <label for="recurso_variavel" style="display: block">Recurso Variável<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="recursoVariavelAutoComplete.atualizar(false)"
                      formControlName="recurso_variavel" name="recurso_variavel_id" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="recurso_variavel_nome" [field]="conversor"
                      [suggestions]="recursoVariavelAutoComplete.lista"
                      (completeMethod)="recursoVariavelAutoComplete.filtrar($event)"
                      placeholder="Informe o Recurso Variável" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="recursoVariavelAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="recursoVariavelAutoComplete">
                      <ng-template let-recurso_variavel pTemplate="item">
                        {{recurso_variavel.codigo}} {{recurso_variavel.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <br />
          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="180px" imagem="assets/img/video-conference.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="modalidade">Modalidade<span class="text-danger">*</span></label>
                  <select [compareWith]="compareFn" id="modalidade" formControlName="modalidade" class="form-control">
                    <option [ngValue]="item" *ngFor="let item of listaModalidades">
                      {{item.codigo}} - {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label for="licitacao">Licitação</label>
                  <p-autoComplete formControlName="licitacao" [field]="licitacaoAutoComplete.conversor"
                    [suggestions]="licitacaoAutoComplete.lista" (completeMethod)="licitacaoAutoComplete.filtrar($event)"
                    inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }" [forceSelection]="true"
                    [autoHighlight]="true" *ngIf="licitacaoAutoComplete">
                    <ng-template let-licitacao pTemplate="item">
                      {{licitacao.numero}}
                    </ng-template>
                  </p-autoComplete>
                </div>

                <div class="form-group col-md-3">
                  <label for="ata">Ata</label>
                  <input formControlName="ata" type="text" class="form-control text-right" id="ata">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="documento">Documento</label>
                  <input formControlName="documento" type="text" class="form-control" id="documento">
                </div>

                <div class="form-group col-md-3">
                  <label for="convenio">Convênio</label>
                  <p-autoComplete formControlName="convenio" [field]="convenioAutoComplete.conversor"
                    [suggestions]="convenioAutoComplete.lista" (completeMethod)="convenioAutoComplete.filtrar($event)"
                    inputStyleClass="form-control" minLength="2" [forceSelection]="true" [autoHighlight]="true"
                    (onBlur)="obterSaldoConvenio()" [style]="{ width: '100%' }" *ngIf="convenioAutoComplete">
                    <ng-template let-convenio pTemplate="item">
                      {{convenio.numero}}/{{convenio.ano}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div *ngIf="entidadeForm.get('contrato').value || entidadeForm.get('convenio').value " class="card mt-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3" *ngIf="entidadeForm.get('contrato').value">
                Saldo contrato <span class="float-right">{{+saldoContrato | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3" *ngIf="entidadeForm.get('convenio').value">
                Saldo convênio <span class="float-right">{{+saldoConvenio | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
          <div *ngIf="entidade.id" class="card mt-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3">
                Empenhado <span class="float-right">{{+empenhado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Liquidado <span class="float-right">{{+liquidado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Pago <span class="float-right">{{+pago | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <br />
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="historico">Histórico<span class="text-danger">*</span></label>
          <button *ngIf="!entidade.id && entidadeForm.get('favorecido').value" data-toggle="modal"
            data-target="#dialogHistoricoFavorecido" class="btn btn-sm btn-link float-right">
            <em class="fa fa-history"></em> Históricos do Beneficiário
          </button>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>